module.exports = __webpack_public_path__ + "static/media/ms.c087e64c.svg";